<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/userView" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.editUser") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="user name"
              >
                <vs-input
                  :label="$t('system.label.userName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="userInfo.username"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="first name"
              >
                <vs-input
                  :label="$t('system.label.firstName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="userInfo.firstname"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="last name"
              >
                <vs-input
                  :label="$t('system.label.lastName')"
                  class="w-full mb-2 font-semibold starlabel"
                  style="margin-bottom: 20px"
                  v-model="userInfo.lastname"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                name="email"
              >
                <vs-input
                  :label="$t('system.label.email')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="userInfo.email"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-checkbox
              class="mt-5 mb-5 font-semibold"
              :value="userInfo.nonlocked"
              >{{ $t("label.checkbox.autogenerate") }}</vs-checkbox
            >
          </div> -->
            <!-- <vs-input
                :label="$t('label.regenerate.password')"
                class="w-full mt-5 mb-5 font-semibold"
                v-model="userData.repeatPassword"
              /> -->
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.availableRoles")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="available roles"
                >
                  <v-select
                    label="name"
                    multiple
                    v-model="roleName"
                    :options="selected"
                    @input="changeName(roleName)"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  <template v-slot:option="option">
                      {{
                        option.clientname
                          ? option.name + " ---- " + option.clientname
                          : option.name
                      }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <!-- <vs-input
                :label="$t('label.input.password')"
                class="w-full mb-5 font-semibold"
                v-model="userData.password"
              /> -->
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.entity")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="entity"
                >
                  <v-select
                    label="name"
                    v-model="officeName"
                    :options="officeList"
                    :reduce="(obj) => obj.id"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button @click="editRole" class="mr-3 mb-2 footerButton-next">{{
            $t("system.label.submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
const createUserObj = {
  sendPasswordToEmail: true,
  roles: [],
  keycloakRoleMappings: [],
  username: "",
  firstname: "",
  lastname: "",
  email: "",
  officeId: 0,
};

export default {
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("RBAC"), to: "" },
        { name: this.$t("system.label.users"), to: "/userView" },
        { name: this.$t("system.label.editUser"), to: "/" },
      ],
      userInfo: createUserObj,
      rolesData: [],
      officeData: [],
      officeList: [],
      selectedOffice: "",
      userData: [],
      offId: "",
      selected: [],
      officeName: "",
      roleName: [],
      data: {},
      warningPopup: false,
      warningText: "Something went wrong",
      errorMessage: "",
    };
  },

  computed: {
    ...mapGetters({ userEditData: "users/getUsersEditData" }),
  },
  methods: {
    async editUserDataById() {
      try {
        this.$store
          .dispatch("users/setUsersEdit", this.$route.params.id)
          .then((response) => {
            const res = response.data;
            this.userInfo.username = res.username
            this.userInfo.firstname = res.firstname
            this.userInfo.lastname = res.lastname
            this.userInfo.email = res.email
            this.officeName = res.officeId
            if (this.data.availableRoles) {
              this.data.availableRoles.forEach((role) => {
                this.selected.push({ name: role.name, clientname: role.clientname });
              });
            }
            if (this.data.allowedOffices) {
              this.data.allowedOffices.forEach((role) => {
                this.officeList.push(role);
              });
            }
            const selectedRoles = res.selectedRoles
            this.roleName = selectedRoles.map((el) => ({
              name: el.name,
              clientname: el.clientname
            }));
            selectedRoles.forEach((r) => {
              const role = this.data.availableRoles.find((e) => e.name === r.name);
              if (role) {
                this.userInfo.roles.push(role.id.toString());

                if (role.keycloakRoles && role.keycloakClients) {
                  this.userInfo.keycloakRoleMappings.push({
                    keycloakRole: role.keycloakRoles,
                    keycloakClient: role.keycloakClients,
                  });
                }
              }
            });
          });
          
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editRole() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      const data ={
        username: this.userInfo.username,
        officeId: this.officeName,
        firstname: this.userInfo.firstname,
        lastname: this.userInfo.lastname,
        email: this.userInfo.email,
        passwordNeverExpires: false,
        isSelfServiceUser: false,
        roles: this.userInfo.roles,
        keycloakRoleMappings: this.userInfo.keycloakRoleMappings
      }
      this.userInfo.roles = this.roleName;
      try {
        const payload = {
          id: this.$route.params.id,
          data: data,
        };
        const resp = await this.$store.dispatch(
          "users/editRoleAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "User Edited Successfully!",
          type: "success",
        });
        if (resp.status == 200) {
          this.$router.push("/userView");
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
        this.warningPopup = true;
      }
    },
    changeName(selectedRoles) {
      this.userInfo.roles = [];
      this.userInfo.keycloakRoleMappings = [];
      selectedRoles.forEach((r) => {
        const role = this.data.availableRoles.find((e) => e.name === r.name);
        if (role) {
          this.userInfo.roles.push(role.id.toString());

          if (role.keycloakRoles && role.keycloakClients) {
            this.userInfo.keycloakRoleMappings.push({
              keycloakRole: role.keycloakRoles,
              keycloakClient: role.keycloakClients,
            });
          }
        }
      });
    },
    async getAvailableData() {
      this.userInfo.keycloakRoleMappings = []
      this.userInfo.roles = []
      try {
        const response = await this.$store.dispatch(
          "users/getUserTemplateData"
        );
        this.data = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/userView");
    },
  },
  async mounted() {
    await this.getAvailableData();
    await this.editUserDataById();
  },
};
</script>
